// Dependencies
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components Styled
import {
  Container,
  DropDownSelectStyled,
  NavContainer,
  SubContainer,
} from './styles';

// Components
import { Accordion } from '../../../../components/navigation/Accordion';
import { BreadCrumbs } from '../../../../components/navigation/Breadcrumbs';

// Icons
import HomeIcon from '../../../../assets/icons/home.svg';

// Routes utils
import { getOptions } from '../../../../router/definitionGloblaRoutes';
import { createRoutes } from '../../../../router/labelToRoutes';
import { getData } from './routes';

// Styles utils

// Custon Hooks
import { useIsSmallDesktop } from '../../../../hooks/useMediaBreakPoints';
import { NavigationFallback } from '../../../../components/navigation/NavigationFallback';

// Redux
import { useAuth } from '../../../../hooks/useAuth';
import { Role } from '../../../../types/auth';
import { filterAllowedRoutes } from '../../../../router/utils';
import { AccordionItem } from '../../../../components/navigation/Accordion/types';
import { OptionSelected } from '../../../../components/inputs/DropDown/DropDownList/types';

export default function ManagementRoutesLayout(): JSX.Element {
  const { t } = useTranslation();
  const location = useLocation();
  // const dispatch = useDispatch();
  const isSmallDesktop = useIsSmallDesktop();
  const routes = location.pathname.split('/');
  routes?.shift();
  const userRole: Role | undefined = useAuth()?.user?.user?.rolActive as
    | Role
    | undefined;

  const dataFiltered = userRole
    ? filterAllowedRoutes(getData(t), userRole)
    : getData(t);
  const optionsFiltered = userRole
    ? filterAllowedRoutes(getOptions(t), userRole)
    : getOptions(t);
  const routesBreadCrumb = createRoutes(routes, [
    {
      content: <img alt={t('navigation:homePage')} src={HomeIcon} />,
      path: '/',
      pathAbsolute: '/',
    },
  ]);

  // const onClickAccordion = useCallback(() => {
  //   dispatch(roidOTSelectedReset());
  // }, []);

  return (
    <Container>
      <BreadCrumbs data={routesBreadCrumb} />
      <SubContainer>
        <NavContainer>
          {isSmallDesktop ? null : (
            <>
              <DropDownSelectStyled
                options={optionsFiltered as OptionSelected[]}
                defaultOption={routes[0]}
              />
              <Accordion
                data={dataFiltered as AccordionItem[]}
              // onItemClick={onClickAccordion}
              />
            </>
          )}
        </NavContainer>
        <NavigationFallback>
          <Outlet />
        </NavigationFallback>
      </SubContainer>
    </Container>
  );
}
